import React from 'react';
import { motion } from 'framer-motion';
import { Gift } from 'lucide-react';
const bonuses = [{
  title: 'Agenda Holística 2026',
  subtitle: 'Un año con propósito',
  desc: 'Calendarios mensuales, planificador semanal, reflexiones de cierre y espacio para rituales y metas.',
  value: '$8.999',
  theme: 'bg-[#FAF7F2]',
  textColor: 'text-gray-900',
  labelColor: 'text-terracotta',
  dividerColor: 'bg-terracotta/40',
  accent: 'text-terracotta',
  titleText: 'Agenda Holística',
  smallLabel: '2026 · Un año con propósito'
}, {
  title: 'Guía de Marketing Faceless',
  subtitle: 'Para Terapeutas Espirituales',
  desc: 'Aprendé a crear contenido, atraer clientas y comunicar tus servicios sin mostrar tu rostro.',
  value: '$15.000',
  theme: 'bg-[#0F0F0F]',
  textColor: 'text-white',
  labelColor: 'text-gold',
  dividerColor: 'bg-gold/40',
  accent: 'text-gold',
  titleText: 'Marketing Faceless',
  smallLabel: 'Guía para Terapeutas'
}, {
  title: 'Planificador de Lanzamiento',
  subtitle: 'Producto Holístico',
  desc: 'Organizá sesiones, ofertas y lanzamientos para convertir tu conocimiento en un emprendimiento real.',
  value: '$10.000',
  theme: 'bg-[#F5EFE6]',
  textColor: 'text-brown',
  labelColor: 'text-brown',
  dividerColor: 'bg-brown/40',
  accent: 'text-brown',
  titleText: 'Lanzamiento Holístico',
  smallLabel: 'Workbook · Plan de Acción'
}];
export function BonusSection() {
  return <section className="py-14 bg-black text-white" data-id="element-30">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-31">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-32">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-gold/10 text-gold font-medium text-sm mb-4 uppercase tracking-wider" data-id="element-33">
            <Gift className="w-4 h-4" data-id="element-34" />
            Oferta Especial
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-2xl md:text-4xl font-serif font-bold mb-4" data-id="element-35">
            Comprando hoy recibís{' '}
            <span className="text-gold italic" data-id="element-36">3 regalos extra</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-base text-gray-400" data-id="element-37">
            Bonos valorados en $33.999 incluidos gratis mientras dure esta
            oferta.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mb-10" data-id="element-38">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.15
        }} className="bg-white/5 border border-white/10 rounded-2xl p-5 pt-7 relative flex flex-col h-full" data-id="element-39">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-terracotta text-white text-[10px] font-bold uppercase tracking-widest py-1 px-3 rounded-full z-20 shadow-lg" data-id="element-40">
                GRATIS HOY
              </div>

              <div className={`w-full max-w-[220px] mx-auto aspect-[5/2] rounded-md mb-4 relative overflow-hidden ring-1 ring-white/5 shadow-md flex flex-col items-center justify-center text-center px-4 ${bonus.theme}`} data-id="element-41">
                <p className={`text-[9px] uppercase tracking-[0.25em] font-semibold mb-1.5 ${bonus.labelColor}`} data-id="element-42">
                  {bonus.smallLabel}
                </p>
                <div className={`w-6 h-px mb-1.5 ${bonus.dividerColor}`} data-id="element-43" />
                <h4 className={`font-serif text-[15px] font-semibold leading-tight ${bonus.textColor}`} data-id="element-44">
                  {bonus.titleText}
                </h4>
              </div>

              <div className="flex-1 flex flex-col text-center" data-id="element-45">
                <h3 className="text-base font-serif font-bold mb-1" data-id="element-46">
                  {bonus.title}
                </h3>
                <p className={`text-xs font-medium mb-2 ${bonus.accent}`} data-id="element-47">
                  {bonus.subtitle}
                </p>
                <p className="text-gray-400 text-sm leading-relaxed mb-4 flex-1" data-id="element-48">
                  {bonus.desc}
                </p>

                <div className="mt-auto bg-gradient-to-r from-terracotta/20 to-terracotta/10 border border-terracotta/30 rounded-lg px-4 py-3 flex items-center justify-between tabular-nums" data-id="element-49">
                  <div className="flex flex-col items-start leading-tight" data-id="element-50">
                    <span className="text-[10px] text-gray-400 uppercase tracking-wider" data-id="element-51">
                      Valor
                    </span>
                    <span className="text-gray-300 line-through font-medium tracking-tight text-base" data-id="element-52">
                      {bonus.value}
                    </span>
                  </div>
                  <span className="text-terracotta-light font-extrabold tracking-wide text-lg" data-id="element-53">
                    GRATIS
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-white/10 border border-white/20 p-5 rounded-xl text-center max-w-2xl mx-auto backdrop-blur-sm tabular-nums" data-id="element-54">
          <p className="text-base md:text-lg text-white tracking-tight" data-id="element-55">
            Total bonus:{' '}
            <span className="line-through text-gray-400 font-medium" data-id="element-56">
              $33.999
            </span>{' '}
            — <span className="text-gold font-bold" data-id="element-57">HOY GRATIS</span> con tu
            Pack
          </p>
        </motion.div>
      </div>
    </section>;
}